import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../../components/Button";

function QuizEndError() {
    const navigate = useNavigate();
    const { courseId, grade, lectureId } = useParams();

    return (
        <section className="flex items-center justify-center w-full h-full">
            <div className="flex flex-col items-center justify-center gap-5 px-20 py-10 rounded-lg bg-gray-color-lighter">
                <img
                    src="/images/SadFace.webp"
                    alt="sad face The quiz time is ended"
                    width="200px"
                    decoding="async"
                    loading="lazy"
                />
                <p className="font-bold text-md lg:text-2xl text-blue-color-primary">
                    لقد انتهى وقت الأمتحان
                </p>

                <Button
                    type="primary"
                    className="w-80"
                    name="go back"
                    onClick={() =>
                        navigate(
                            `/${grade}/courses/${courseId}/lectures/${lectureId}`,
                            { replace: true }
                        )
                    }
                >
                    عودة للمحاضره
                </Button>
            </div>
        </section>
    );
}

export default QuizEndError;
